import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Loader from "../../../../img/Document scan.gif"
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";

const SiteSubjectStatusList = ({ onMouseDown, tableRef }) => {
  const [subjectStatusList, setSubjectStatusList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  let { studyId } = useParams();

  const getStudySiteSubjectStatus = async () => {
    setDataLoader(true);
    let data = await studySiteDataEntryServices.getStudySiteSubjectStatus(studyId, "edc", StudyMode);
    setSubjectStatusList(data?.data || [])
    setDataLoader(false);
  };

  const downloadCSV = (data) => {
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Site Name",
      "Subject Name",
      "Subject Status",
      "Screening Date",
      "Screening Status",
      "Completion Status",
      "Discontinue Status",
      "Randomization Status",
    ];
    const rows = data.map((row, index) => [
      index + 1,
      row.siteName || "",
      row.subjectName || "",
      row.status || "",
      row.screeningDate || "",
      row.screenStatus || "",
      row.complitionStatus || "",
      row.discontinueStatus || "",
      row.randomizationStatus || "",
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "subject_status.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = (data) => {
    if (!data || !data.length) return;
    const excelData = data.map((row, index) => ({
      "Sr.": index + 1,
      "Site Name": row.siteName,
      "Subject Name": row.subjectName,
      "Subject Status": row.status,
      "Screening Date": row.screeningDate,
      "Screening Status": row.screenStatus,
      "Completion Status": row.complitionStatus,
      "Discontinue Status": row.discontinueStatus,
      "Randomization Status": row.randomizationStatus,
    }));
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Status");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "subject_status.xlsx");
  };

  useEffect(() => {
    getStudySiteSubjectStatus();
  }, []);

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-2">
          <div className="gap-1 hstack">
            <button
              onClick={() => downloadCSV(subjectStatusList)}
              className={`updateProfile`}
            >
              Download CSV
            </button>
            <button
              onClick={() => downloadExcel(subjectStatusList)}
              className={`updateProfile`}
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>
      {dataLoader ? (
        <div className="hstack justify-content-center"
          style={{ height: "calc(100vh - 181px)" }}>
          <img src={Loader} alt="Page Loader" />
        </div>
      ) : subjectStatusList?.length === 0 ? (
        <NoDataFoundTable MSG={"Data Not Found!"} />
      ) : (
        <>
          <div className="overflow-auto" style={{ height: "calc(100vh - 181px)" }}>
            <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    className="text-center"
                    style={{ width: 45 }}
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Site Name</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Subject Name</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Subject Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Screening Date</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Screening Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Complition Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 7)}>Discontinue Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 8)}>Randomization Status</th>
                </tr>
              </thead>
              <tbody>
                {(subjectStatusList || []).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      {rowIndex + 1}
                    </td>
                    <td>{row?.siteName}</td>
                    <td>{row?.subjectName}</td>
                    <td>{row?.status}</td>
                    <td>{row?.screeningDate}</td>
                    <td>{row?.screenStatus}</td>
                    <td>{row?.complitionStatus}</td>
                    <td>{row?.discontinueStatus}</td>
                    <td>{row?.randomizationStatus}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </>
  );
};

export default SiteSubjectStatusList;